import wixData from 'wix-data';
import wixWindow from 'wix-window';
import wixBookings from 'wix-bookings';
//import wixUsers from 'wix-users';

//import wixLocation from 'wix-location';

let selectedSlot;
let isBooking;

let fadeEffect = { "duration": 300, "delay": 0};
let slideEffect = { "duration": 200, "delay": 0, "direction": "bottom" };

$w.onReady(function () {
    //multilingual
    let lang = wixWindow.multilingual.currentLanguage;
    /*if (lang === 'en') {
        //store categories
        $w("#hebCats").hide();
        $w("#engCats").show();
        //menu
        $w("#hebMenu").hide();
        $w("#engMenu").show();
    }*/

    let serviceId;
    //products
    /*$w("#dsProducts").onReady(() => {
        $w("#rpProducts").onItemReady(($item, itemData, index) => {
            //quick view
            $item("#quickViewHover").onMouseIn((event) => {
                console.log("in");
                $w("#quickView").hide("slide", slideEffect);
                $item("#quickView").show("slide", slideEffect);
            });
            $item("#quickView").onMouseOut((event) => {
                console.log("out");
                $item("#quickView").hide("slide", slideEffect);
            });
            $item("#quickView").onClick((event) => {
                $item("#quickView").hide();
                wixWindow.openLightbox("quickView", itemData)
                    .then((data) => {

                    })
                    .catch((err) => {
                        console.log(err);
                    })
                $item("#quickView").hide(slideEffect);
            });

            //ribbon
            let ribbon = itemData.ribbons[0];
            if (ribbon) {
                $item("#ribbon").text = ribbon.text;
                $item("#boxRibbon").show();
            }

            //hover
            let mediaItem = itemData.mediaItems[1];
            if (mediaItem) {
                let hoverImage = setPictureUrl(mediaItem.src);
                $item("#hover").src = hoverImage;
            }
            $item("#image").onMouseIn((event) => {
                mediaItem = itemData.mediaItems[1];
                if (mediaItem) {
                    $item("#hover").show();
                }
            });
            $item("#hover").onMouseOut((event) => {
                $item("#hover").hide();
            });
        });
    });*/
});

export function setPictureUrl(image) {
    image = image.substr(15);
    image = image.slice(0, image.lastIndexOf("/"));
    let picutre = "https://static.wixstatic.com/media/".concat(image);
    return picutre;
}

export function meetingsC_mouseIn(event) {
	$w("#box1").show("fade", fadeEffect);
    $w("#b1").hide("fade", fadeEffect);
    $w("#box2").hide("fade", fadeEffect);
    $w("#b2").show("fade", fadeEffect);
}

export function meetingsHover_mouseIn(event) {
	$w("#box1").show("fade", fadeEffect);
    $w("#b1").hide("fade", fadeEffect);
    $w("#b2").show("fade", fadeEffect);
    $w("#box2").hide("fade", fadeEffect);
}

export function box1_mouseOut(event) {    
    $w("#b1").show("fade", fadeEffect);
	$w("#box1").hide("fade", fadeEffect);
    $w("#b2").show("fade", fadeEffect);
	$w("#box2").hide("fade", fadeEffect);
}

export function storeC_mouseIn(event) {
	$w("#box2").show("fade", fadeEffect);
    $w("#b2").hide("fade", fadeEffect);
    $w("#box1").hide("fade", fadeEffect);
    $w("#b1").show("fade", fadeEffect);
}

export function storeHover_mouseIn(event) {
	$w("#box2").show("fade", fadeEffect);
    $w("#b2").hide("fade", fadeEffect);
    $w("#b2").show("fade", fadeEffect);
    $w("#box2").hide("fade", fadeEffect);
}

export function storeHover_mouseOut(event) {
	$w("#b2").show("fade", fadeEffect);
	$w("#box2").hide("fade", fadeEffect);
    $w("#b1").show("fade", fadeEffect);
	$w("#box1").hide("fade", fadeEffect);
}

export function columnStrip3_mouseOut(event) {
	$w("#b1").show("fade", fadeEffect);
	$w("#box1").hide("fade", fadeEffect);
    $w("#b2").show("fade", fadeEffect);
	$w("#box2").hide("fade", fadeEffect);
}

export function meetingsC_mouseOut(event) {
	$w("#b1").show("fade", fadeEffect);
	$w("#box1").hide("fade", fadeEffect);
    $w("#b2").show("fade", fadeEffect);
	$w("#box2").hide("fade", fadeEffect);
}